<section id="login" class="bg-cage">

  <div *ngIf="event" class="container-fluid">

    <div class="row full-height-vh">
        <div class="col-md-6 col-xs-12 left-column" [style.background-image]="'url(' + event.eventbackgroundUrl + ')'"></div>

        <div class="col-md-6 col-xs-12 align-items-center justify-content-center right-column" style="background: #F2F2F2">
          <div class="img-mobile">
              <img [src]="event.eventBackgroundMobileUrl" width="100%" height="auto">
          </div>
          <div class="logo-container">
            <img [src]="event.eventLogoUrl" width="141px">
          </div>
          <div class="card-container">
              <div class="card  text-center width-320">
                  <div class="card-body">
                      <div class="card-block">
                          <h1 style="margin-bottom: 16px">Login</h1>
                          <form novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                              <div class="form-group" style="margin-bottom: 16px">
                                  <div class="col-md-12">
                                      <input type="username" class="form-control form-control-login" name="inputUser" id="inputEmail" placeholder="Email"
                                             [(ngModel)]="request.username" required>
                                  </div>
                              </div>

                              <div class="form-group col-md-12" style="margin-bottom: 16px">
                                  <div class="position-relative has-icon-right">
                                      <input class="form-control form-control-login" name="inputPass" id="inputPass" placeholder="Password"
                                             name="form-control-with-icon"
                                             type="{{showPassword ? 'text' : 'password'}}" [(ngModel)]="request.password" required>
                                      <div class="form-control-position">
                                          <i class="cursor-pointer ft-eye{{showPassword ? '' : '-off'}} primary font-medium-3"
                                             (click)="showPassword = !showPassword"></i>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-md-12">
                                  <div class="custom-control custom-checkbox">
                                      <input type="checkbox" class="custom-control-input" id="customCheck1" [(ngModel)]="isChecked" [ngModelOptions]="{standalone: true}">
                                      <label  class="custom-control-label" for="customCheck1"><a href="https://www.bccveronavicenza.it/template/default.asp?i_menuID=57418" target="_blank" style="font-weight: 400">Autorizzo il trattamento dei dati personali forniti ai sensi del D. Lgs. 196/2003 e all’art. 13 del Regolamento UE 2016/679.</a></label>
                                  </div>
                              </div>
                              <div class="card-footer">
                                  <button type="submit" class="btn btn-primary full-width" >Login</button>
                              </div>
                              <div class="text-center rec-pass">
                                  <a style="font-size: 12px" routerLink="/login/reset-password"><p>Password dimenticata?</p></a>
                              </div>
                          </form>
                      </div>
                  </div>

              </div>
          </div>
            <!--Autorizzo il trattamento dei dati personali forniti ai sensi del D. Lgs. 196/2003 e all’art. 13 del Regolamento UE 2016/679.-->
          <div class="contatti text-center footer-absolute" style="padding-top: 1rem; color: #ffffff">
              <div [innerHTML]="event.eventFooter"></div>
          </div>
      </div>
    </div>

  </div>

</section>
